import { Link } from "react-router-dom";
import { whatsappPhoneOpen } from '../../utils';

const NotFound = () => {
    return (
        <div style={styles.page}>
            <div style={styles.blob1} />
            <div style={styles.blob2} />
            <div style={styles.blob3} />

            <div className="uen-notfound-card" style={styles.card}>
                <span style={styles.eyebrow}>Erro 404</span>

                <h1 className="uen-notfound-code" style={styles.code}>
                    4<span style={styles.codeAccent}>0</span>4
                </h1>

                <h2 className="uen-notfound-headline" style={styles.headline}>
                    Página não encontrada
                </h2>

                <p style={styles.message}>
                    O link que você acessou não existe, foi movido ou expirou.
                    Vamos te levar de volta.
                </p>

                <div className="uen-notfound-actions" style={styles.actions}>
                    <Link to="/" style={styles.primaryBtn}>
                        ← Voltar para o início
                    </Link>
                    <Link to="/login" style={styles.secondaryBtn}>
                        Acessar minha conta
                    </Link>
                </div>

                <button
                    type="button"
                    onClick={whatsappPhoneOpen}
                    style={styles.support}
                >
                    Precisa de ajuda?{' '}
                    <span style={styles.supportLink}>Fale com o suporte</span>
                </button>
            </div>

            <style>{`
                @keyframes uenFloat {
                    0%, 100% { transform: translateY(0px); }
                    50%      { transform: translateY(-10px); }
                }
                @keyframes uenPulse {
                    0%, 100% { opacity: 0.55; transform: scale(1); }
                    50%      { opacity: 0.85; transform: scale(1.05); }
                }
                @media (max-width: 640px) {
                    .uen-notfound-card {
                        padding: 40px 24px !important;
                        border-radius: 20px !important;
                    }
                    .uen-notfound-code     { font-size: 96px !important; }
                    .uen-notfound-headline { font-size: 22px !important; }
                    .uen-notfound-actions  { flex-direction: column !important; width: 100%; }
                    .uen-notfound-actions a { width: 100% !important; }
                }
                @media (max-width: 380px) {
                    .uen-notfound-code { font-size: 80px !important; }
                }
            `}</style>
        </div>
    );
};

const PRIMARY = '#006437';
const PRIMARY_DARK = '#004d2a';
const ACCENT = '#31cc8d';

const styles = {
    page: {
        position: 'relative',
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '32px 16px',
        background: 'linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 50%, #f0f9ff 100%)',
        fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
        overflow: 'hidden',
        boxSizing: 'border-box',
    },
    blob1: {
        position: 'absolute',
        top: '-120px',
        left: '-120px',
        width: '360px',
        height: '360px',
        borderRadius: '50%',
        background: `radial-gradient(circle, ${ACCENT}55, transparent 70%)`,
        filter: 'blur(20px)',
        animation: 'uenPulse 6s ease-in-out infinite',
        pointerEvents: 'none',
    },
    blob2: {
        position: 'absolute',
        bottom: '-160px',
        right: '-100px',
        width: '420px',
        height: '420px',
        borderRadius: '50%',
        background: `radial-gradient(circle, ${PRIMARY}40, transparent 70%)`,
        filter: 'blur(24px)',
        animation: 'uenPulse 8s ease-in-out infinite 1s',
        pointerEvents: 'none',
    },
    blob3: {
        position: 'absolute',
        top: '20%',
        right: '15%',
        width: '180px',
        height: '180px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, #fef9c355, transparent 70%)',
        filter: 'blur(18px)',
        animation: 'uenPulse 7s ease-in-out infinite 2s',
        pointerEvents: 'none',
    },
    card: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        gap: 0,
        width: '100%',
        maxWidth: '560px',
        padding: '56px 48px',
        background: 'rgba(255, 255, 255, 0.72)',
        backdropFilter: 'blur(14px)',
        WebkitBackdropFilter: 'blur(14px)',
        border: '1px solid rgba(255, 255, 255, 0.6)',
        borderRadius: '28px',
        boxShadow: '0 30px 80px -20px rgba(0, 100, 55, 0.18)',
    },
    eyebrow: {
        display: 'inline-block',
        padding: '4px 12px',
        borderRadius: '999px',
        backgroundColor: `${PRIMARY}15`,
        color: PRIMARY,
        fontSize: '12px',
        fontWeight: 700,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        marginBottom: '20px',
    },
    code: {
        fontSize: '140px',
        fontWeight: 900,
        lineHeight: 1,
        margin: '0 0 8px',
        background: `linear-gradient(135deg, ${PRIMARY} 0%, ${ACCENT} 100%)`,
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        letterSpacing: '-0.04em',
        animation: 'uenFloat 5s ease-in-out infinite',
    },
    codeAccent: {
        background: `linear-gradient(135deg, ${ACCENT} 0%, ${PRIMARY_DARK} 100%)`,
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
    },
    headline: {
        fontSize: '26px',
        fontWeight: 800,
        color: '#0f172a',
        margin: '8px 0 12px',
    },
    message: {
        fontSize: '15px',
        lineHeight: 1.6,
        color: '#475569',
        margin: '0 0 32px',
        maxWidth: '420px',
    },
    actions: {
        display: 'flex',
        gap: '12px',
        flexWrap: 'wrap',
        justifyContent: 'center',
        marginBottom: '24px',
        width: '100%',
    },
    primaryBtn: {
        padding: '14px 28px',
        backgroundColor: PRIMARY,
        color: '#fff',
        textDecoration: 'none',
        borderRadius: '12px',
        fontWeight: 700,
        fontSize: '15px',
        boxShadow: `0 8px 20px -6px ${PRIMARY}80`,
        transition: 'transform 0.15s, box-shadow 0.15s',
        display: 'inline-block',
        textAlign: 'center',
    },
    secondaryBtn: {
        padding: '14px 28px',
        backgroundColor: 'transparent',
        color: PRIMARY,
        textDecoration: 'none',
        borderRadius: '12px',
        fontWeight: 700,
        fontSize: '15px',
        border: `2px solid ${PRIMARY}30`,
        transition: 'background-color 0.15s, border-color 0.15s',
        display: 'inline-block',
        textAlign: 'center',
    },
    support: {
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        color: '#64748b',
        fontSize: '14px',
    },
    supportLink: {
        color: PRIMARY,
        fontWeight: 700,
        textDecoration: 'underline',
        textUnderlineOffset: '3px',
    },
};

export default NotFound;
